export const CONTROLLER_WIDGET_ACTUATE_ON_INTERFACE = '[CONTROLLER_DASHBOARD] CONTROLLER_WIDGET_ACTUATE_ON_INTERFACE';